import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import OnboardingWelcomeStep from "./onboardingWelcomeStep";
import styles from "./onboardingSuccess.module.css";
import i18n from "../../i18n";

const OnboardingSuccess: React.FC = () => {
  const { companyId } = useParams<{ companyId?: string }>();

  // Detect if page is opened inside an iframe and notify parent via postMessage
  useEffect(() => {
    if (window.self !== window.top) {
      // Inside iframe → send message to parent window to navigate
      const currentUrl = window.location.href;
      // Send message to parent with the current origin for security
      window.parent.postMessage(
        {
          type: 'PAYMENT_SUCCESS',
          url: currentUrl,
        },
        window.location.origin // Send only to the same origin
      );
    }
  }, []);

  // Placeholder / fallback data
  const companyValues = {
    name: "",
    email: "",
  };

  // Try to extract optional data from URL params
  const urlParams = new URLSearchParams(window.location.search);
  const companyName = urlParams.get("companyName") || companyValues.name;
  const companyEmail = urlParams.get("email") || companyValues.email;

  return (
    <section className={styles.section} dir={i18n.dir()}>
      <OnboardingWelcomeStep
        values={{
          name: companyName,
          email: companyEmail,
        }}
      />
    </section>
  );
};

export default OnboardingSuccess;
